module.exports = __webpack_public_path__ + "assets/arrow.4c944f9b.svg";